// extracted by mini-css-extract-plugin
export var changeIcon = "_4c-4";
export var container = "_4c-0";
export var divider = "_4c-7";
export var externalLinkIcon = "_4c-1";
export var green = "_4c-5";
export var helpCircleIcon = "_4c-3";
export var iconButton = "_4c-2";
export var red = "_4c-6";